import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback } from 'react';
import { Input as Input$1 } from '@chakra-ui/react';
import { withInputAddons } from './hoc/with-input-addons.js';
import { FieldTypes } from '../../types.js';
var _excluded = ["type"];
var InputWithElements = withInputAddons('Input')(Input$1);
var Input = function Input(_ref) {
  var type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var toggleShowPassword = useCallback(function () {
    return setShowPassword(!showPassword);
  }, [showPassword]);
  return /*#__PURE__*/React.createElement(InputWithElements, _extends({
    "data-object-type": "input",
    type: type === FieldTypes.password && showPassword ? FieldTypes.text : type
  }, props, {
    toggleShowPassword: type === FieldTypes.password ? toggleShowPassword : undefined,
    showPassword: type === FieldTypes.password ? showPassword : undefined,
    sx: {
      '::-webkit-search-cancel-button': {
        display: 'none'
      }
    }
  }));
};
Input.displayName = "Input";
export { Input };